// Central image registry. Replace AI/stock placeholders with real HARSPRO photography later.
export const IMAGES = {
  heroSuv:
    "/assets/hars/4c1ea8c93d76e59d4e30606c3476ff9d4312b66479b5f8e7a9b8c2eb79a8db16.jpeg",
  hoodMacro:
    "/assets/hars/b5670253326cd2f448bc6c9b001f870f05bf9769319b0b162423f68f108f6be8.jpeg",
  panelSurface:
    "/assets/hars/202b86314dec93905369a299e767058b6557c80abf88457bfc1c310cef7f22de.jpeg",
  interiorView:
    "/assets/hars/9e8f68b55b8701f0aa0a1015bdb4359b04102fff045e8475803318e1de3bc2bc.jpeg",
  wrapCar:
    "https://images.unsplash.com/photo-1760713164476-7eb5063b3d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blackSuv:
    "https://images.unsplash.com/photo-1653227203074-ea5ac3ed9476?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blackCoupe:
    "https://images.unsplash.com/photo-1610475426033-e6411e62b767?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  // Services
  servicePpf:
    "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  serviceTint:
    "https://images.unsplash.com/photo-1760713164476-7eb5063b3d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  serviceWrap:
    "https://images.unsplash.com/photo-1595536511320-f1078b27bdf8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Gallery — mix of wraps, detailing and luxury cars.
export const GALLERY = [
  "https://images.unsplash.com/photo-1712600641185-b6611344887f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1658058765823-835c5093546a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1595536511320-f1078b27bdf8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1601936253396-65e0f2989343?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1632823469850-2f77dd9c7f93?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1653227203074-ea5ac3ed9476?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1610475426033-e6411e62b767?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
];
